var r=function(r){return"string"==typeof r||"number"==typeof r};export{r as isValidStringOrNumber};
